import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useEffect } from 'react';
const CHUNK_RELOAD_KEY = 'pricing-pages-chunk-reload';
function isChunkLoadError(error) {
  return error.name === 'ChunkLoadError' || /loading chunk .* failed/i.test(error.message) || /loadable.*split chunk/i.test(error.message);
}

// After a deploy, browsers with stale HTML try to fetch chunks that no longer
// exist (hashes changed). One reload fetches the new HTML with correct chunk
// URLs. sessionStorage prevents infinite reload loops.
function ChunkLoadErrorFallback({
  error
}) {
  const chunkError = isChunkLoadError(error);
  const hasReloaded = (() => {
    try {
      return !!sessionStorage.getItem(CHUNK_RELOAD_KEY);
    } catch (_unused) {
      return false;
    }
  })();
  useEffect(() => {
    if (chunkError && !hasReloaded) {
      try {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      } catch (_unused2) {
        return;
      }
      window.location.reload();
    }
  }, [chunkError, hasReloaded]);
  if (chunkError && !hasReloaded) {
    return null;
  }
  if (chunkError) {
    // Reload already attempted and still failing — clear flag so future visits can retry.
    try {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    } catch (_unused3) {
      // ignore
    }
  }
  return null;
}
function DeferredSectionLoading() {
  return null;
}
export function createDeferredLoadable(typedLoader,
/* Optional placeholder shown while the chunk loads. Defaults to rendering
 * nothing; pass a skeleton to reserve a section's space during the load. */
LoadingComponent = DeferredSectionLoading) {
  return Loadable({
    typedLoader,
    LoadingComponent,
    ErrorComponent: ChunkLoadErrorFallback,
    delay: 0
  });
}